import React, { useState } from "react";
import ReactQuill , { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import useStyles from "./style";


// Optional: Add custom fonts
const Font = Quill.import('formats/font');
Font.whitelist = ['sans-serif', 'serif', 'monospace', 'arial', 'comic-sans', 'courier-new'];
Quill.register(Font, true);

// Optional: Add custom sizes
const Size = Quill.import('formats/size');
Size.whitelist = ['small', 'normal', 'large', 'huge'];
Quill.register(Size, true);

const TextEditor = ({ initialHtmlContent ="", onHtmlContentChange }) => {
const classes = useStyles();
  const [value, setValue] = useState(initialHtmlContent);

  const handleChange = (content, delta, source, editor) => {
    setValue(content);
    if (onHtmlContentChange) {
      onHtmlContentChange(content);
    }
  };

  const modules = {
    toolbar: [
      [{ 'font': Font.whitelist }],           // Font family
      [{ 'size': Size.whitelist }],           // Font size
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // Headers
      ['bold', 'italic', 'underline', 'strike'],  // Text styles
      [{ 'color': [] }, { 'background': [] }],    // Colors
      [{ 'script': 'sub'}, { 'script': 'super' }], // Sub/Superscript
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }], // Lists & Indent
      [{ 'align': [] }],                        // Alignment
      ['link', 'image', 'video'],               // Media options
      ['blockquote', 'code-block'],             // Blockquote & Code
      ['clean']                                 // Remove formatting
    ],
    clipboard: {
      matchVisual: false,
    }
  };

  const formats = [
    'font', 'size',
    'header', 'bold', 'italic', 'underline', 'strike', 
    'color', 'background',
    'script',
    'list', 'bullet', 'indent',
    'align',
    'link', 'image', 'video',
    'blockquote', 'code-block'
  ];

  return (
    <>
      <header className={classes.AppHeader}>CMS EDITOR</header>
      <br />
            <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Start writing here..."
      />
    </>
  );
};

export default TextEditor;
